import React from "react";
import "./Input.css";

interface Props {
  type?: string;
  placeholder: string;
  text: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
}

function Input({ type, placeholder, text, onChange, onFocus }: Props) {
  return (
    <input
      className="user-input focus:outline-none bg-white border rounded-none border-gray-200 opacity-100 text-sm w-full"
      type={type ?? "text"}
      value={text}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={onFocus}
      autoComplete={type === "email" ? "email" : "off"}
    />
  );
}

export { Input };
